import { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteAnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site-content`)
      .then((response) => setAnnouncement(response.data.announcement))
      .catch(() => setAnnouncement(null));
  }, []);

  if (!announcement?.enabled || !announcement?.message) return null;

  return (
    <div className="border-b border-black bg-[#1a1a1a] px-6 py-3" data-testid="site-announcement-banner">
      <div className="max-w-7xl mx-auto flex items-start justify-center gap-3 text-center sm:text-left">
        <Megaphone className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#42D78A]" />
        <p className="text-sm font-medium text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {announcement.message}
        </p>
      </div>
    </div>
  );
};

export default SiteAnnouncementBanner;
